import React from 'react'
import AboutContent from '../components/AboutContent'

const About = () => {
  return (
    <AboutContent />
  )
}

export default About